// src/components/SocialMediaFeed.js
import React, { useState } from 'react';
import styles from '../App.module.css';

const SocialMediaFeed = () => {
  const [loading, setLoading] = useState(false)
  return (
    <>
    {
      loading ? (
        <div className="animate-pulse bg-slate-500 w-full">
            <div className="w-full bg-slate-500 py-5">
              <h2 className="text-5xl font-bold uppercase text-center text-white mb-5">Social Media Feed</h2>
              <div className="container grid grid-cols-4 gap-2">
                <div role="status" className="max-w-sm border border-gray-200 rounded shadow animate-pulse dark:border-gray-700">
                  <div className="flex items-center justify-center h-60 mb-1 bg-gray-300 rounded dark:bg-gray-700">
                    <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                      <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"/>
                      <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"/>
                    </svg>
                  </div>
                  <div className="p-2">
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded w-5/6 dark:bg-gray-700"></div>
                    <div className="flex items-center mt-4">
                      <svg className="w-10 h-10 me-3 text-gray-200 dark:text-gray-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
                      </svg>
                      <div>
                        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
                        <div className="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div role="status" className="max-w-sm border border-gray-200 rounded shadow animate-pulse dark:border-gray-700">
                  <div className="flex items-center justify-center h-60 mb-1 bg-gray-300 rounded dark:bg-gray-700">
                    <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                      <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"/>
                      <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"/>
                    </svg>
                  </div>
                  <div className="p-2">
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded w-5/6 dark:bg-gray-700"></div>
                    <div className="flex items-center mt-4">
                      <svg className="w-10 h-10 me-3 text-gray-200 dark:text-gray-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
                      </svg>
                      <div>
                        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
                        <div className="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div role="status" className="max-w-sm border border-gray-200 rounded shadow animate-pulse dark:border-gray-700">
                  <div className="flex items-center justify-center h-60 mb-1 bg-gray-300 rounded dark:bg-gray-700">
                    <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                      <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"/>
                      <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"/>
                    </svg>
                  </div>
                  <div className="p-2">
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded w-5/6 dark:bg-gray-700"></div>
                    <div className="flex items-center mt-4">
                      <svg className="w-10 h-10 me-3 text-gray-200 dark:text-gray-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
                      </svg>
                      <div>
                        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
                        <div className="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div role="status" className="max-w-sm border border-gray-200 rounded shadow animate-pulse dark:border-gray-700">
                  <div className="flex items-center justify-center h-60 mb-1 bg-gray-300 rounded dark:bg-gray-700">
                    <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                      <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"/>
                      <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"/>
                    </svg>
                  </div>
                  <div className="p-2">
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded dark:bg-gray-700 mb-2"></div>
                    <div className="h-2.5 bg-gray-200 rounded w-5/6 dark:bg-gray-700"></div>
                    <div className="flex items-center mt-4">
                      <svg className="w-10 h-10 me-3 text-gray-200 dark:text-gray-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
                      </svg>
                      <div>
                        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
                        <div className="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-10 bg-gray-200 mx-auto rounded w-28 mt-5 dark:bg-gray-700 mb-2"></div>
            </div>
          </div>
      ):(        
        <section id="social-media-feed" className="py-20 bg-dark text-white" data-aos="fade-up">
          <div className="container-fluid mx-auto text-center">
            <div className="row">
              <div className="col-md-12">            
                <h2 className="text-5xl font-bold uppercase text-white mb-5">Social Media Feed</h2>
              </div>
              <div className="col-md-12">
                <div className={styles.social_media_wrapper}>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_1.png' alt="Facebook Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/facebook-logo.png' alt="Facebook Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_2.png' alt="Linkedin Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/linkedin-logo.png' alt="Linkedin Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_3.png' alt="Instagram Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/instagram-logo.png' alt="Instagram Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_4.png' alt="Twitter Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/twitter-logo.png' alt="Twitter Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_1.png' alt="Facebook Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/facebook-logo.png' alt="Facebook Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_1.png' alt="Facebook Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/facebook-logo.png' alt="Facebook Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_2.png' alt="Linkedin Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/linkedin-logo.png' alt="Linkedin Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_3.png' alt="Instagram Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/instagram-logo.png' alt="Instagram Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_4.png' alt="Twitter Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/twitter-logo.png' alt="Twitter Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                  <div className={`bg-white ${styles.social_media_cards}`}>
                    <div className='media-img position-relative'>                  
                      <img loading="lazy" src='./images/post_1.png' alt="Facebook Feed" />
                      <div className={styles.social_icon}>
                        <img loading="lazy" src='./images/facebook-logo.png' alt="Facebook Icon" />
                      </div>
                    </div>
                    <div className="p-2">                  
                      <p className="content mb-0 text-gray-500 text-xs text-start">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                      </p>
                      <div className="d-flex align-items-center mt-3 text-start">
                        <img loading="lazy" src='./images/user_profile.png' alt="User Profile" className='w-10' />
                        <div className='ms-2'>
                          <p className="text-black font-bold mb-0">SP Nainawal</p>
                          <p className="text-gray-500 mb-0 text-xs">Executive Director... 22h Ago</p>
                        </div>
                      </div>
                    </div>
                    <hr style={{borderBottom:"1px solid #858484"}}/>
                    <div className="d-flex align-items-center justify-between px-2 pb-3">
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/like.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/retweet.png' alt="Like" />0</p>
                        <p className="mb-0 text-l text-gray-300 px-2"><img loading="lazy" className='d-inline' src='./images/comment.png' alt="Like" />0</p>
                      </div>
                      <div className="d-flex align-items-center justify-between">
                        <p className="mb-0 text-l"><img loading="lazy" src='./images/share.png' alt="Like" /></p>
                      </div>
                    </div>
                  </div>
                </div>
                <button className='text-black uppercase bg-white p-2 text-xs font-semibold px-4 mt-5 rounded-sm'>Show more</button>
              </div>
            </div>
          </div>
        </section>
      )
    }
    </>
  );
}

export default SocialMediaFeed;
